module.exports = __webpack_public_path__ + "img/icon-hint.45e3bf50.svg";